import React, { Component } from "react";

export default class Loader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 300);
  }
  render() {
    const { loading } = this.state;
    return (
      <>
        {loading ? (
          <div
            id="js-preloader"
            className="js-preloader"
            style={{ display: "flex!important" }}
          >
            <div className="preloader-inner">
              <span className="dot"></span>
              <div className="dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
}
